<template>
  <div
    v-if="visible"
    class="pointer-events-none absolute inset-0 z-10 flex items-center justify-center bg-purple-100/70"
  >
    <div
      class="rounded-xl border-2 border-dashed border-purple-400 px-8 py-6 text-purple-700"
    >
      <Icon name="image" class="mx-auto mb-2 size-8" />
      <p class="text-sm font-medium">Drop image here</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from "@/components/Core/Icon.vue";

defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
});
</script>
